<template>
  <div v-if="categories != null">
    <div class="bg-white p-4 rounded-md">
      <p class="font-bold text-xl pb-2 tracking-tight text-gray-900">
        {{ selectedCategory?.businessName || "Documents contractuels" }}
      </p>
      <div v-if="selectedCategory" class="space-y-2">
        <button
          v-if="selectedCategory.contractDistribution?.summaryUrl"
          type="button"
          class="px-3 py-1.5 text-sm rounded-lg bg-primary-light hover:bg-primary transition-colors text-primary-dark hover:text-white flex items-center gap-2 group"
          @click="summaryModalOpen = true"
        >
          <span>Afficher le résumé des garanties</span>
          <ChevronRightIcon class="h-4 w-4 transform transition-transform" />
        </button>
        <div v-if="isMpcp" class="space-y-1">
          <a
            v-if="selectedCategory.ipidUrl"
            class="font-medium text-primary-dark hover:underline"
            :href="selectedCategory.ipidUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="flex items-center">
              <DocumentIcon class="h-4 w-4 mr-1" />
              <p class="text-sm">DIPA</p>
            </div>
          </a>
          <a
            v-if="selectedCategory.cgUrl"
            class="font-medium text-primary-dark hover:underline"
            :href="selectedCategory.cgUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="flex items-center">
              <DocumentIcon class="h-4 w-4 mr-1" />
              <p class="text-sm">Notice d'information</p>
            </div>
          </a>
        </div>
        <div v-else>
          <a
            class="font-medium text-primary-dark hover:underline"
            :href="selectedCategory.marketingPage"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="flex items-center">
              <DocumentIcon class="h-4 w-4 mr-1" />
              <p class="text-sm">Documents contractuels</p>
            </div>
          </a>
        </div>
      </div>
      <div v-else>
        <p class="text-gray-500 text-sm">{{ $t("Select an insurance plan.") }}</p>
      </div>
    </div>
    <ContractSummaryModal
      :open="summaryModalOpen"
      :url="summaryModalUrl"
      :title="summaryModalTitle"
      @close="summaryModalOpen = false"
    />
  </div>
</template>

<script>
import { DocumentIcon, ChevronRightIcon } from "@heroicons/vue/outline";
import { isMpcpCategory } from "@estaly/ui";
import ContractSummaryModal from "./ContractSummaryModal.vue";

export default {
  components: {
    DocumentIcon,
    ChevronRightIcon,
    ContractSummaryModal,
  },

  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    productCategoryValue: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      summaryModalOpen: false,
    };
  },

  computed: {
    selectedCategory() {
      if (!this.productCategoryValue || !Array.isArray(this.categories)) return null;
      return this.categories.find((c) => c?.productCategoryName === this.productCategoryValue) ?? null;
    },
    summaryModalUrl() {
      return this.selectedCategory?.contractDistribution?.summaryUrl || "";
    },
    summaryModalTitle() {
      return this.selectedCategory?.businessName || "";
    },
    isMpcp() {
      return isMpcpCategory(this.productCategoryValue);
    },
  },
};
</script>
